import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import App from './App.tsx';
import './index.css';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorHandler } from '@/components/Common/ErrorHandler/ErrorHandler.tsx';
import { authConfig } from './env-exports';
import { Toaster } from './components/index.ts';

const oidcConfig: AuthProviderProps = {
  authority: authConfig.authority,
  client_id: authConfig.clientId,
  scope: authConfig.scopes,
  response_type: 'code',
  redirect_uri: authConfig.redirectUri,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  post_logout_redirect_uri: authConfig.postLogoutRedirectUri,
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={ErrorHandler}>
      <AuthProvider {...oidcConfig}>
        <App />
        <Toaster position="top-center" richColors theme="dark" toastOptions={{ duration: 3000 }} />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
